let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("503rY")).then(() => parcelRequire('ecW9b'));